import {useParams} from 'react-router-dom'
import cn from 'clsx'

import styles from './RequestSecurityItems.module.scss'
import useStore from 'base/store'
import { PermissionType } from 'common/types'
import {SecurityItems, useGetSecurityItems} from 'modules/project'
import {
  Block,
  IconTitle,
  IconButton,
  Box,
  Text,
  Button,
  Loader,
  Modal,
  VerticalDivider,
  HouseExchangeSecondIcon,
  DotsIcon,
} from 'common/components'
import {formatMoney, totalNumberFromArray} from 'common/helpers'
import {useGetRequest, isMilestonePassed} from '..'

export default function RequestSecurityItems() {
  const params = useParams()
  const {data: request} = useGetRequest(params.uuid)
  const permissions: PermissionType[] = useStore((state) => state.permissions)
  const {data: securityItems, isRefetching: securityItemsRefetching} =
    useGetSecurityItems(request?.project?.uuid, !!request?.project?.uuid)
  const isSecurityItemsOpen = useStore((state) => state.isSecurityItemsOpen)
  const setSecurityItemsOpen = useStore((state) => state.setSecurityItemsOpen)

  const handleSecurityItemsOpen = () => setSecurityItemsOpen(true)

  const handleSecurityItemsClose = () => setSecurityItemsOpen(false)

  const creationDisabled = !permissions?.includes('edit security') || securityItemsRefetching

  const isPassed = isMilestonePassed('security-items-added', request)

  const activeItems = securityItems
    ? securityItems.filter((item) => item.status !== 'discharged')
    : []

  return (
    <>
      <Block relative type="white">
        <div className={cn(styles.section, isPassed && styles.section_total)}>
          <IconTitle icon={<HouseExchangeSecondIcon />}>
            Security items
          </IconTitle>
          {!isPassed ? (
            (!!permissions?.includes('edit loan request (lm check)')) &&
            <Button
              variant="secondary"
              disabled={creationDisabled}
              onClick={handleSecurityItemsOpen}
            >
              add
            </Button>
          ) : securityItems ? (
            <div className={styles.total}>
              {!creationDisabled && (
                !!permissions?.includes('edit loan request (lm check)')
                ) && (
                <IconButton
                  className={styles.edit}
                  onClick={handleSecurityItemsOpen}
                >
                  <DotsIcon />
                </IconButton>
              )}
              <Box align="right">
                <Text size="xs" weight="medium" color="grey" mb={2}>
                  Items
                </Text>
                <Text size="3xl" weight="medium">
                  {activeItems.length}
                </Text>
              </Box>
              <VerticalDivider />
              <Box align="right">
                <Text size="xs" weight="medium" color="grey" mb={2}>
                  Security value
                </Text>
                <Text size="3xl" weight="medium">
                  {formatMoney(
                    totalNumberFromArray(
                      activeItems.map(
                        (item) => item.improvementValue + item.landValue
                      )
                    )
                  )}
                </Text>
              </Box>
            </div>
          ) : (
            <Loader />
          )}
        </div>
      </Block>
      <Modal
        title="Security items"
        width={960}
        open={isSecurityItemsOpen}
        onCancel={handleSecurityItemsClose}
      >
        <SecurityItems isRequest items={securityItems} />
      </Modal>
    </>
  )
}
